import { render, staticRenderFns } from "./DeliveryHeatmap.vue?vue&type=template&id=65cd2bd7"
import script from "./DeliveryHeatmap.vue?vue&type=script&lang=js"
export * from "./DeliveryHeatmap.vue?vue&type=script&lang=js"
import style0 from "./DeliveryHeatmap.vue?vue&type=style&index=0&id=65cd2bd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports